import { cn } from '@/lib/utils';
import { type Size, spinnerSizes } from '@/theme/size-tokens';

type SpinnerProps = {
  size?: Size;
  variant?: 'primary' | 'teal' | 'neutral';
  className?: string;
  speed?: string;
} & React.HTMLAttributes<HTMLDivElement>;

function Spinner({
  size = 'xl',
  variant = 'primary',
  className,
  speed,
  ...props
}: Readonly<SpinnerProps>) {
  const sizeConfig = spinnerSizes[size];

  const variantTopBorder = {
    primary: 'border-t-primary',
    teal: 'border-t-teal',
    neutral: 'border-t-neutral',
  }[variant];

  const duration = speed ? `[animation-duration:${speed}]` : '';

  return (
    <div
      role="status"
      data-slot="spinner"
      aria-label="Loading"
      className={cn(
        'border-muted inline-block box-border animate-spin rounded-full',
        variantTopBorder,
        sizeConfig.classes,
        sizeConfig.border,
        duration,
        className
      )}
      {...props}
    >
      <span className="sr-only">Loading...</span>
    </div>
  );
}

export { Spinner };
export type { SpinnerProps };
